export default __webpack_public_path__ + "static/speedy1-a1b3c2a82f227a8c465f533ddeb08cf5.svg";